<template>
    <div class="pc-blockdetail inner-box">
        <Bread
            backTitle="全部区块"
            backRouter="/block"
            secTitle="区块详情"
        ></Bread>
        <div class="title">
            <h1>
                <i class="iconfont iconqukuaixiangqinglogo"></i>
                <span>区块高度&nbsp;&nbsp;{{ block.infos.height }}</span>
            </h1>
            <p class="hash">区块哈希&nbsp;&nbsp;{{ block.infos.hash }}</p>
            <p
                class="copy-btn"
                v-clipboard:copy="block.infos.hash"
                v-clipboard:success="success"
                v-clipboard:error="error"
            >
                复制
            </p>
        </div>
        <!-- 区块信息 -->
        <BlockInfo :infos="block.infos"></BlockInfo>
        <!-- 数据记录 -->
        <div class="tx-record table-shadow">
            <h2>数据记录</h2>
            <!-- 表格部分 -->
            <el-table
                :data="block.txs"
                stripe
                style="width: 100%"
                class="data-table"
                :cell-class-name="groupCellName"
                empty-text="暂无数据"
                v-loading="loading"
                element-loading-text="拼命加载中..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
            >
                <el-table-column label width="20">
                    <template v-slot="item">
                        <div>
                            <div
                                :class="{
                                    'start-line': item.row.tradeG === 3,
                                    'middle-line': item.row.tradeG === 1,
                                    'end-line': item.row.tradeG === 2,
                                }"
                            >
                                <span v-if="item.row.tradeG === 3"></span>
                                <i></i>
                                <span v-if="item.row.tradeG !== 3"></span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="上链哈希" width="220">
                    <template v-slot="item">
                        <div>
                            <p class="group-title" v-if="item.row.tradeG === 3">
                                数据组
                            </p>
                            <router-link
                                :to="`/tradeHash?hash=${item.row.txHash}`"
                                class="light flex-left"
                            >
                                <i
                                    class="iconfont err-ico"
                                    :class="{
                                        'iconjinggao-chucuo': tradeAccuracy(
                                            item.row.tx.execer,
                                            item.row.receipt.ty,
                                            item.row.receipt.tyName
                                        ),
                                    }"
                                ></i>
                                {{ filterHash(item.row.txHash) }}
                            </router-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="hash" label="发送方" align="center">
                    <template v-slot="item">
                        <router-link
                            :to="`/address?address=${item.row.fromAddr}`"
                            class="light"
                            >{{
                                filterHash(item.row.fromAddr, 20)
                            }}</router-link
                        >
                    </template>
                </el-table-column>
                <el-table-column width="60" align="center">
                    <template v-slot>
                        <i class="iconfont iconjiantou-you"></i>
                    </template>
                </el-table-column>
                <el-table-column prop="hash" label="接收方" align="center">
                    <template v-slot="item">
                        <router-link
                            :to="`/address?address=${item.row.tx.to}`"
                            class="light"
                            >{{ filterHash(item.row.tx.to, 20) }}</router-link
                        >
                    </template>
                </el-table-column>
                <el-table-column label="上链时间" width="200" align="center">
                    <template v-slot="item">{{
                        formatTime(item.row.blockTime)
                    }}</template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 底部分页 -->
        <div class="bottom-page flex-right">
            <PageContainer
                @pageChange="pageChange"
                @sizeChange="sizeChange"
                :currentPage="pages.currentPage"
                :pageSize="pages.pageSize"
                :total="pages.total"
            ></PageContainer>
        </div>
    </div>
</template>

<script setup>
import { tradeAccuracy, formatTime, filterHash } from "@/utils/filters";
import Bread from "@/components/computer/Breadcrumb.vue";
import PageContainer from "@/components/computer/PageContainer.vue";
import BlockInfo from "./BlockInfos";
import { groupCellName } from "@/mixins/common";
import BlockMixins from "@/mixins/blockDetail";
import { useRoute } from "vue-router";
import { success, error } from "@/mixins/common";
import { watch } from "vue";

const { getBlock, block, loading, pages, pageChange, sizeChange } =
    BlockMixins();
const route = useRoute();
watch(
    () => route.query.height,
    (height) => {
        pages.currentPage = 1;
        getBlock(height);
    },
    {
        immediate: true,
    }
);
</script>

<style lang="scss">
.pc-blockdetail {
    .title {
        margin: 28px 0 20px;
        .iconqukuaixiangqinglogo {
            color: $blue;
            font-size: 20px;
        }
        span {
            margin-left: 10px;
            color: $black;
            font-size: 20px;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
        }
        .hash {
            display: inline-block;
            margin-top: 6px;
            padding-left: 30px;
            font-size: 14px;
            color: $black;
        }
    }
    .tx-record {
        margin-top: 30px;
        border: 1px solid #ebeff1;
        .err-ico {
            color: #e45359;
            font-size: 12px;
            width: 13px;
            margin-right: 5px;
            display: inline-flex;
        }
        h2 {
            height: 81px;
            line-height: 81px;
            padding-left: 25px;
            font-size: 16px;
            color: $black;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
            background: $white;
            border-bottom: 1px solid #ececec;
        }
        .data-table {
            .el-table__header thead tr {
                height: 60px;
            }
            .iconjiantou-you {
                font-size: 20px;
                color: #9aaab9;
            }
            .tx-start,
            .tx-middle,
            .tx-end {
                background: $group_bg;
                .light,
                .iconjiantou-you {
                    color: $group_title;
                }
            }
            .tx-start {
                padding-top: 45px;
            }
            .tx-start:nth-of-type(2) {
                padding-top: 0;
                // .cell {
                //   padding: 0;
                // }
            }
            .tx-start:nth-of-type(1),
            .tx-middle:nth-of-type(1),
            .tx-end:nth-of-type(1) {
                padding: 0;
                text-align: right;
                span {
                    background: $group_title;
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    display: block;
                }
                i {
                    margin: 0 auto;
                    display: block;
                    width: 1px;
                    background: $group_title;
                }
                .start-line {
                    position: absolute;
                    bottom: 0;
                    width: 5px;
                    span {
                        margin: 0 auto;
                    }
                    i {
                        height: 27.5px;
                    }
                }
                .middle-line {
                    width: 5px;
                    span {
                        position: absolute;
                        top: 45%;
                    }
                    i {
                        height: 67px;
                    }
                }
                .end-line {
                    position: absolute;
                    top: 0;
                    width: 5px;
                    span {
                        margin: 0 auto;
                    }
                    i {
                        height: 27.5px;
                    }
                }
            }
            .group-title {
                margin: 15px 0 9px 20px;
                font-size: 14px;
                font-family: PingFangSC-Semibold;
                font-weight: 500;
                color: $group_title;
            }
        }
        .token-icon {
            height: 26px;
        }
    }
    .bottom-page {
        margin-top: 23px;
    }
    .loading-line {
        height: 60px;
        line-height: 18px;
    }
    .el-table tr,
    .el-table td {
        border: 0;
    }
    .el-table th:nth-of-type(2) .cell {
        padding-left: 30px;
    }
    .el-loading-mask {
        top: 60px;
    }
}
</style>
